import styled from "styled-components";
import { Button } from "react-bootstrap";
import { colors, types } from "../../../libs";

export const FormContainer = styled.div`
  margin-top: 24px;
  padding: 8px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  ${types.body.normal};
  color: ${colors.text.white};
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  background: ${colors.background.formField};
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: ${colors.text.white};
  ${types.body.normal};
  
  &:focus {
    outline: none;
    border-color: ${colors.background.green};
  }
  
  &::placeholder {
    color: ${colors.text.disabled};
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px;
  background: ${colors.background.formField};
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: ${colors.text.white};
  ${types.body.normal};
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: ${colors.background.green};
  }
  
  option {
    background: ${colors.background.formField};
    color: ${colors.text.white};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

export const SaveButton = styled(Button)`
  background: ${colors.background.green};
  color: ${colors.text.black};
  padding: 10px 24px;
  border: none;
  flex: 1;
  
  &:hover {
    background: ${colors.background.lightGreen};
  }
`;

export const CancelButton = styled(Button)`
  background: ${colors.background.lightGrey};
  color: ${colors.text.white};
  padding: 10px 24px;
  border: none;
  flex: 1;
  
  &:hover {
    background: ${colors.background.greyWhite};
  }
`;

export const HelpText = styled.div`
  ${types.body.small};
  color: ${colors.text.disabled};
  margin-top: 6px;
  font-style: italic;
`;
